/**
 * Rejection Dialog Validation Schemas
 *
 * Shared validation for rejection/approval workflows across the application.
 * Used in waste orders, school requests, and lesson answers approval processes.
 *
 * Created: 2025-11-02 (Phase 5 - Admin Forms Refactoring)
 */

import { z } from 'zod';

/**
 * Rejection Reason Schema
 *
 * Validates rejection reason field for approval workflows.
 * Requires non-empty string with Romanian error message.
 */
export const rejectionSchema = z.object({
  /**
   * Rejection reason text (required)
   * Displayed to users when their request/order/submission is rejected
   */
  rejectReason: z
    .string()
    .min(1, 'Motivul respingerii este obligatoriu')
    .trim(),
});

/**
 * TypeScript type inferred from Zod schema
 * Use this type for form data in components
 */
export type RejectionFormData = z.infer<typeof rejectionSchema>;
